import React from 'react';

import useCollectionSelectionController from './useCollectionSelectionController';
import useMeasurementSelectionController from './useMeasurementSelectionController';
import useProviderSelectionController from './useProviderSelectionController';

// Hand-copied mirror of the controller's return value so the React context can be typed.
export type KpiFilterController = {
  collectionSelection: any;
  extendedSearch: {
    set: (arg0: ((arg0: boolean) => boolean) | boolean) => void;
    value: boolean;
  };
  measurementSelection: any;
  providerSelection: any;
  search: {
    onChange: (arg0: ((arg0: string) => string) | string) => void;
    value: string;
  };
  sum: {
    set: (arg0: ((arg0: boolean) => boolean) | boolean) => void;
    toggle: () => void;
    value: boolean;
  };
  active: {
    value: boolean;
    set: (arg0: ((arg0: boolean) => boolean) | boolean) => void;
  };
};

function useKpiFilterController() {
  // `sum` is parentOnly in the measurementRangeSearchPg query: true means the search is NOT extended.
  const [sum, setSum] = React.useState<boolean>(true);
  const [active, setActive] = React.useState<boolean>(false);
  const [search, setSearch] = React.useState<string>('');
  const providerSelection = useProviderSelectionController();
  // TODO: The Collection filter is being replaced by "Search"; remove once the transition completes.
  const collectionSelection = useCollectionSelectionController();
  const measurementSelection = useMeasurementSelectionController();
  const toggleSum = React.useCallback(() => setSum((s) => !s), [setSum]);

  return {
    providerSelection,
    collectionSelection,
    measurementSelection,
    search: {
      value: search,
      onChange: setSearch,
    },
    sum: {
      value: sum,
      toggle: toggleSum,
      set: setSum,
    },
    active: {
      value: active,
      set: setActive,
    },
  };
}

export default useKpiFilterController;
